import { Plug, LayoutDashboard } from "lucide-react";
import { LeadsInbox } from "./LeadsInbox";

const DELIVERY_OPTIONS = [
  {
    icon: Plug,
    title: "Direct CRM integration",
    description:
      "Leads route straight into your CRM or marketing platform the moment someone submits, with the answers they gave attached for context. Your team can follow up right where they already work.",
  },
  {
    icon: LayoutDashboard,
    title: "Provided lead dashboard",
    description:
      "Prefer not to wire up your CRM? We provide a lead dashboard so your team can review every submission, the inputs behind it and the follow-up context in one place.",
  },
];

export function LeadsInboxSection() {
  return (
    <section
      id="lead-delivery"
      className="overflow-hidden border-t border-border/50 bg-[#080E1E]/95 px-5 py-12 sm:px-6 sm:py-16 md:px-8 md:py-20 lg:px-12"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid min-w-0 gap-8 sm:gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:items-center">
          <div className="flex min-w-0 flex-col space-y-5 leading-relaxed text-muted-foreground sm:space-y-6 lg:text-lg">
            <div className="space-y-3">
              <p className="text-sm font-semibold tracking-[0.22em] uppercase text-primary">
                Where Leads Land
              </p>
              <h2 className="text-3xl sm:text-4xl font-semibold leading-tight text-white">
                Your Business, With <span className="text-primary">Inbound Leads</span>.
              </h2>
            </div>
            <div className="space-y-4 max-w-prose">
              <p>
                Every tool we build feeds your business inbound leads, not just page views. When someone finishes a calculator, assessment or visualizer, they arrive as a named lead with real intent, and the answers they gave tell your sales team exactly what they care about.
              </p>
              <p>
                You choose how those leads reach your team:
              </p>
            </div>
            <div className="grid min-w-0 gap-4 sm:grid-cols-2">
              {DELIVERY_OPTIONS.map(({ icon: Icon, title, description }) => (
                <div
                  key={title}
                   className="flex min-w-0 flex-col gap-3 rounded-xl border border-white/10 bg-white/[0.04] p-4 sm:rounded-2xl sm:p-5"
                >
                  <span
                    className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-primary/30 bg-primary/15"
                    aria-hidden="true"
                  >
                    <Icon className="h-4.5 w-4.5 text-primary" />
                  </span>
                  <h3 className="text-base font-semibold text-white">{title}</h3>
                  <p className="text-sm leading-relaxed text-muted-foreground">{description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative min-w-0">
            <span
              className="pointer-events-none absolute inset-8 rounded-full bg-primary/15 blur-3xl"
              aria-hidden="true"
            />
            <div className="relative flex min-h-[390px] min-w-0 items-center sm:min-h-[420px]">
              <LeadsInbox />
            </div>
            <p className="mt-4 text-xs text-muted-foreground/80 text-center">
              Simulation: the kind of lead activity your tools generate, shown as your team would see it.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
